import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { EntityDefinitionIdIterator } from "./entity-definition-id-iterator";
import { QueryResultBase } from "./entity-query-result";
import { IIdIterator } from "./id-iterator";
import { IIdQueryResult } from "./id-query-result";

export class EntityDefinitionIdQueryResult extends QueryResultBase<number> implements IIdQueryResult {
    private readonly _client: IContentHubClient;

    items: Array<number>;

    constructor(client: IContentHubClient, items: Array<number>, totalItems: number, offset: number) {
        super(totalItems, offset);

        Guard.notNullOrUndefined(client);
        Guard.notNullOrUndefined(items);

        this._client = client;
        this.items = items;
    }

    createIterator(): IIdIterator {
        return new EntityDefinitionIdIterator(this._client, this);
    }
}
